import { EasyForm } from './EasyForm'
import { HardForm } from './HardForm'

export const InvestigationAccidents = ({accident, onClose}) => {
	const checkEasyLevel = !accident.isMoreOne && (accident.injureds?.[0]?.severity?.severityDegreeCode?.code === 'L' || accident.injureds?.[0]?.severity?.severityDegreeCode?.code === 'M')
	const checkHardLevel = accident.isMoreOne

	console.log('checkLevel', {
		checkEasyLevel,
		checkHardLevel,
		accident
	})

	if(checkEasyLevel){
		return <EasyForm accident={accident}/>
	}

	if(checkHardLevel){
		return <HardForm accident={accident}/>
	}
}